import useTranslationSetup from "../../utils/useTranslationSetup";
import { FAIL_REASON_TO_MESSAGE_KEY } from "../../utils/CommonUtils/constants";
import snrCheckImg from "../../assets/snr_vad_check.svg";
import "./AudioQualityWarningBanner.css";

function AudioQualityWarningBanner({ failReason }) {
  const { t, activeLanguage } = useTranslationSetup();

  if (!failReason || !FAIL_REASON_TO_MESSAGE_KEY[failReason]) {
    return null;
  }

  return (
    <div className="audio-quality-warning-banner">
      <img
        src={snrCheckImg}
        alt=""
        aria-hidden
      />
      <p className="audio-quality-warning-banner-text" lang={activeLanguage}>
        {t(FAIL_REASON_TO_MESSAGE_KEY[failReason])}
      </p>
    </div>
  );
}

export default AudioQualityWarningBanner;
